export const fieldsName = {
  name: 'Name',
  telephoneNumber: 'Phone Number',
  undefined: '',
  supportedManufacturers: 'Brands',
  supportedWorkTypes: 'Work Types',
  supportedFuelTypes: 'Fuel Types',
  supportedInsurances: 'Insurances',
  supportedProviders: 'Affiliations',
  supportedBanks: 'Bank',
  bankIban: 'IBAN',
  workdays: 'Workdays',
};
